// @ts-ignore
import translations from './translations.json';


export * from './components';
export * from './hooks';
export * from './constants';

export const ui = {
    translations,
};
